import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Editor from 'react-simple-code-editor';
import { highlight, languages } from "prismjs";
import 'prismjs/components/prism-json';
// import { highlight, languages } from 'prismjs/components/prism-core';
// // import "prismjs/components/prism-yaml";
import "prismjs/themes/prism-dark.css";
// import "prismjs/plugins/line-numbers/prism-line-numbers";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import history from "../../store/history";
import SubmitButton from "../button/SubmitButton";
import CancelButton from "../button/CancelButton";
import {
    showSuccessAlert,
    showErrorAlert,
    showWarningAlert
} from "../../store/actions/alerts";
import makeApiRequest from "../../utils/axios/new-axios";
import Redoc from "./Redoc";
import AsyncApi from "./AsyncApi";

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        minHeight: '95vh',
        maxHeight: '95vh',
        minWidth: '95vw',
        maxWidth: '95vw',
        backgroundColor: "black"
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: "white",
    },
}));


export default function ApiDocEditor({
    openModal,
    handleCloseModal,
    jsonString,
    url,
    method,
    returnUrl,
    specType,
    dataWrapper,
    dataWrapperPath,
    dataWrapperMethod,
    doc
}) {

    const dispatch = useDispatch();
    const classes = useStyles();

    const [text, setText] = useState(jsonString);
    const [preview, setPreview] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const formatJson = () => {
        try {
            if (text && text.trim().length > 0) {
                const formated = JSON.parse(text);
                setText(JSON.stringify(formated, null, 4));
            }

        } catch (error) {
            dispatch(showErrorAlert("JSON Format Error: " + error.message));
        }
    }

    useEffect(() => {
        formatJson();
        // eslint-disable-next-line
    }, [])

    const previewDoc = () => {
        if (preview) {
            setPreview(null)
        } else {
            try {
                if (text && text.trim().length > 0) {

                    if (dataWrapper && dataWrapperPath && dataWrapperMethod) {
                        const formated = JSON.parse(text.replace("AUTO_INSERT_METHOD", dataWrapperMethod));
                        const docData = JSON.parse(dataWrapper);
                        if (specType === "asyncapi") {
                            docData.channels = {
                                [dataWrapperPath]: formated
                            };
                        } else {
                            docData.paths = {
                                [dataWrapperPath]: {
                                    [dataWrapperMethod]: formated
                                }
                            };
                        }

                        setPreview(docData);

                    } else {

                        let newText = text;
                        newText = newText.replace("AUTO_INSERT_SPEC_TYPE", doc.specType)
                            .replace("AUTO_INSERT_SPEC_VERSION", doc.specVersion)
                            .replace("AUTO_INSERT_NAME", doc.name)
                            .replace("AUTO_INSERT_VERSION", doc.version)
                            .replace("AUTO_INSERT_DESCRIPTION", doc.description)
                            .replace("AUTO_INSERT_DEV_URL", doc.devUrl)
                            .replace("AUTO_INSERT_LIVE_URL", doc.liveUrl);

                        const formated = JSON.parse(newText);

                        setPreview(formated);
                    }
                }
            } catch (error) {
                dispatch(showErrorAlert("Not in JSON format: " + error.message));
            }
        }
    }

    const updateData = async () => {
        setIsSubmitting(true);
        try {
            if (text && text.trim().length > 0) {
                const parsed = JSON.parse(text);
                const formattedText = JSON.stringify(parsed);

                await makeApiRequest({
                    url,
                    method,
                    data: {
                        data: formattedText
                    }
                }).then((response) => {
                    setIsSubmitting(false);
                    if (response.data.affectedRows > 0) {
                        dispatch(showSuccessAlert(`Updated Successfully!`));
                        history.push(returnUrl);
                    } else {
                        dispatch(showWarningAlert(`Nothing updated. But no errors!`));
                    }
                }).catch((error) => {
                    setIsSubmitting(false);
                    dispatch(
                        showErrorAlert(
                            "Error : " +
                            (!!error.response
                                ? `${error.response.status}! - ${error.response.data.errorMessage}`
                                : error.message)
                        )
                    );
                });
            }

        } catch (error) {
            dispatch(showErrorAlert("Not in JSON format: " + error.message));
            setIsSubmitting(false);
        }
    }


    return (
        <Dialog
            open={openModal}
            onClose={handleCloseModal}
            fullWidth={true}
            maxWidth="lg"
            aria-labelledby="api-doc-viewer"
            aria-describedby="api-doc-viewer"
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            disableEnforceFocus={true}
            classes={{ paper: classes.dialogPaper }}
        >
            <DialogTitle id="api-doc-title">
                <Typography >JSON Code Editor</Typography>
                <IconButton aria-label="close" className={classes.closeButton} onClick={handleCloseModal} disabled={isSubmitting}>
                    <CloseIcon />
                </IconButton>

            </DialogTitle>

            <DialogContent dividers>
                {!preview ?
                    <Editor
                        value={text}
                        onValueChange={code => setText(code)}
                        highlight={code => highlight(code, languages.json)}
                        padding={10}
                        style={{
                            fontFamily: '"Fira code", "Fira Mono", monospace',
                            fontSize: 15,
                            backgroundColor: "black",
                            caretColor: "white",
                            color: "white",
                            height: "100%"
                        }}

                    /> : <>
                        {specType === "asyncapi" ?
                            <AsyncApi spec={preview} /> : <Redoc spec={preview} />}

                    </>}

            </DialogContent>

            <DialogActions>
                <CancelButton
                    disabled={isSubmitting || !!preview}
                    onClick={() => formatJson()}
                >
                    Format
                </CancelButton>
                <CancelButton
                    disabled={isSubmitting}
                    onClick={() => previewDoc()}
                >
                    {`${!!preview ? "Close Preview" : "Preview"}`}
                </CancelButton>
                <SubmitButton
                    disabled={isSubmitting || !!preview}
                    isSubmitting={isSubmitting}
                    onClick={updateData}
                >
                    Update
                </SubmitButton>
            </DialogActions>

        </Dialog>
    )
}
